import { NavLink } from 'react-router-dom';
import { Home, Trophy, Award } from 'lucide-react';

export default function BottomNav() {
  const navItems = [
    { name: 'Home', path: '/app', icon: Home },
    { name: 'Leaderboard', path: '/app/leaderboard', icon: Trophy },
    { name: 'Badges', path: '/app/badges', icon: Award },
  ];

  return (
    <nav className="bottom-nav">
      {navItems.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/app'}
            className={({ isActive }) =>
              `bottom-nav-item ${isActive ? 'active' : ''}`
            }
          >
            <Icon size={24} />
            <span className="text-xs mt-1 font-medium">{item.name}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
